<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div>
    <div v-if="!hasLetter">
      <div class="row" style="height: 500px;">
        <div class="col-md-4">
          <img
            class="imgleft"
            src="https://cdn.exploreve.fr/content/personnages/daria.svg"
            height="400px"
            style="z-index: 0;"
          />
          <img
            class="imgleft"
            src="https://cdn.exploreve.fr/content/personnages/erwin.svg"
            height="400px"
            style="position: relative; top: 280px; z-index: 0;"
          />
        </div>
        <div class="col-md-4">
          <div class="right" style="max-width: 300px !important; top: 100px;">
            <p>Je suis désolé, je ne peux pas vous parler pour l’instant !</p>
            <div class="arrowright"></div>
          </div>
        </div>
        <div class="col-md-4">
          <img class="imgright" src="https://cdn.exploreve.fr/content/cluedo/Sartaq.svg" height="400px" />
        </div>
      </div>
    </div>
    <b-container v-else>
      <div class="slideshow-container">
        <!-- Full-width images with number and caption text -->
        <div class="mySlides">
          <div class="row">
            <div class="col-md-4">
              <img class="imgleft" src="https://cdn.exploreve.fr/content/personnages/daria.svg" height="400px" />
            </div>
            <div class="col-md-4">
              <div class="right">
                <p>नमस्कार साथियों, bonjour les ami·es &nbsp;!</p>
                <div class="arrowright"></div>
              </div>
              <div class="left">
                <div class="arrowleft"></div>
                <p>Bonjour, on a une lettre pour vous !</p>
              </div>
              <div class="right">
                <p>Merci beaucoup. D'où est-ce que vous venez ?</p>
                <div class="arrowright"></div>
              </div>
              <div class="left">
                <div class="arrowleft"></div>
                <p>Oh, de très loin ! *rires*</p>
              </div>
            </div>
            <div class="col-md-4">
              <img class="imgright" src="https://cdn.exploreve.fr/content/cluedo/Sartaq.svg" height="400px" />
            </div>
          </div>
        </div>

        <div class="mySlides">
          <div class="row">
            <div class="col-md-4">
              <img class="imgleft erwin" src="https://cdn.exploreve.fr/content/personnages/erwin.svg" height="400px" />
            </div>
            <div class="col-md-4">
              <div class="right">
                <p>Plus loin que nous ? On vient d'Inde ! Nous sommes la patrouille des Élephants.</p>
                <div class="arrowright"></div>
              </div>
              <div class="left">
                <div class="arrowleft"></div>
                <p>Wow ! D'Inde !</p>
              </div>
            </div>
            <div class="col-md-4">
              <img class="imgright" src="https://cdn.exploreve.fr/content/cluedo/Sartaq.svg" height="400px" />
            </div>
          </div>
        </div>

        <div class="mySlides">
          <div class="row">
            <div class="col-md-4">
              <img class="imgleft erwin" src="https://cdn.exploreve.fr/content/personnages/erwin.svg" height="400px" />
            </div>
            <div class="col-md-4">
              <div class="right">
                <p>
                  Oui, nous avons fait long voyage. C’est beau de voir autant de nations réunies dans la Paix après la
                  terrible guerre que le monde a vécue… Nous sommes plus de 70 délégations étrangères, et d’autres
                  viennent de loin comme nous. Des Pakistanais, des Taïwanais, des Américains... Et pour nous, c’est un
                  moment important, notre pays vient de gagner son indépendance !
                </p>
                <div class="arrowright"></div>
              </div>
            </div>
            <div class="col-md-4">
              <img class="imgright" src="https://cdn.exploreve.fr/content/cluedo/Sartaq.svg" height="400px" />
            </div>
          </div>
        </div>

        <div class="mySlides">
          <div class="row">
            <div class="col-md-4">
              <img class="imgleft erwin" src="https://cdn.exploreve.fr/content/personnages/erwin.svg" height="400px" />
            </div>
            <div class="col-md-4">
              <div class="left">
                <div class="arrowleft"></div>
                <p>C'est hyper impressionnant... Il porte bien son nom de Jamboree de la Paix !</p>
              </div>
              <div class="right">
                C'est vrai que c'est un beau symbole ! Avez-vous besoin d'autre chose ?
                <div class="arrowright"></div>
              </div>
            </div>
            <div class="col-md-4">
              <img class="imgright" src="https://cdn.exploreve.fr/content/cluedo/Sartaq.svg" height="400px" />
            </div>
          </div>
        </div>

        <div class="mySlides">
          <div class="row">
            <div class="col-md-4">
              <img class="imgleft" src="https://cdn.exploreve.fr/content/personnages/daria.svg" height="400px" />
            </div>
            <div class="col-md-4">
              <div class="left">
                <div class="arrowleft"></div>
                <p>
                  On aurait une requête particulière. Notre petit doigt nous a dit que vous aviez de très beaux tissus !
                  Nous en aurions bien besoin pour réparer notre ballon.
                </p>
              </div>
              <div class="right">
                <p>
                  Nous pouvons bien vous en donner. Cependant, nous n'en donnons pas à n'importe qui ! Il faudra nous
                  prouver que vous les méritez.
                </p>
                <div class="arrowright"></div>
              </div>
            </div>
            <div class="col-md-4">
              <img class="imgright" src="https://cdn.exploreve.fr/content/cluedo/Sartaq.svg" height="400px" />
            </div>
          </div>
        </div>

        <div class="mySlides">
          <div class="row">
            <div class="col-md-4">
              <img class="imgleft" src="https://cdn.exploreve.fr/content/personnages/daria.svg" height="400px" />
            </div>
            <div class="col-md-4">
              <div class="left">
                <div class="arrowleft"></div>
                <p>Que devons-nous faire ?</p>
              </div>
              <div class="right">
                <p>Si vous mémorisez et retrouvez par paires nos plus beaux tissus, nous vous en donnerons un !</p>
                <div class="arrowright"></div>
              </div>
              <div class="left">
                <div class="arrowleft"></div>
                <p>Défi relevé !</p>
              </div>

              <div class="object" v-on:click="plusSlides(1)">Relever le défi !</div>
            </div>
            <div class="col-md-4">
              <img class="imgright" src="https://cdn.exploreve.fr/content/cluedo/Sartaq.svg" height="400px" />
            </div>
          </div>
        </div>

        <div class="mySlides">
          <div class="row">
            <div class="col-md-6">
              <div class="card-container">
                <div v-for="n in cards.length" :key="n" class="front">
                  <div class="flip-card">
                    <div class="flip-card-inner" :id="n">
                      <div class="flip-card-front" v-on:click="flip">
                        <img
                          class="pix_mem"
                          src="https://cdn.exploreve.fr/content/cluedo/Tissus/dos_des_cartes_mémory.svg"
                        />
                      </div>
                      <div class="flip-card-back" v-on:click="flip">
                        <img
                          class="pix_mem"
                          :src="'https://cdn.exploreve.fr/content/cluedo/Tissus/Motif-tissus-' + cards[n - 1] + '.svg'"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="right" style="margin-top: 100px;">
                <p>
                  Pour gagner le tissu, essaye de trouver les morceaux de tissus similaires. Clique sur deux morceaux de
                  tissus pour les retourner. S'ils sont identiques, ils resteront retournés. Sinon, ils retourneront
                  face cachée. Bon courage !
                </p>
                <div class="arrowright"></div>
              </div>
            </div>
            <div class="col-md-3 sartaq_mem">
              <img class="imgright" src="https://cdn.exploreve.fr/content/cluedo/Sartaq.svg" height="400px" />
            </div>
          </div>
        </div>

        <div class="mySlides">
          <div class="row">
            <div class="col-md-6">
              <div style="text-align: center;">
                <img src="https://cdn.exploreve.fr/content/cluedo/Tissus-plié.svg" height="400px" />
              </div>
            </div>
            <div class="col-md-3">
              <div class="right" style="margin-top: 100px;">
                Bravo ! Voici un tissu indien, garde-le bien !
                <div class="arrowright"></div>
              </div>
            </div>
            <div class="col-md-3 sartaq_mem">
              <img class="imgright" src="https://cdn.exploreve.fr/content/cluedo/Sartaq.svg" height="400px" />
            </div>
          </div>
        </div>
      </div>

      <!-- The dots/circles -->
      <div style="text-align: center;">
        <a class="prev" v-on:click="plusSlides(-1)">&#10094;</a>
        <span class="dot" v-on:click="currentSlide(1)"></span>
        <span class="dot" v-on:click="currentSlide(2)"></span>
        <span class="dot" v-on:click="currentSlide(3)"></span>
        <span class="dot" v-on:click="currentSlide(4)"></span>
        <span class="dot" v-on:click="currentSlide(5)"></span>
        <span class="dot" v-on:click="currentSlide(6)"></span>
        <a class="next" v-on:click="plusSlides(1)">&#10095;</a>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      slideIndex: 1,
      cards: [1, 2, 5, 2, 6, 7, 4, 3, 8, 4, 6, 1, 7, 5, 3, 8],
      flipped: Array(16).fill(false),
      pair: -1
    };
  },
  mounted() {
    this.currentSlide(1);
  },
  props: {
    hasLetter: Boolean
  },
  methods: {
    flip(event) {
      var ref = this;
      var el = event.target.parentElement;
      if (!el.classList.contains("flip-card-inner")) {
        el = el.parentElement;
      }
      if (!el.classList.contains("blocked")) {
        if (el.classList.contains("back")) {
          el.classList.remove("back");
          el.classList.add("front");
        } else {
          el.classList.add("back");
          el.classList.remove("front");

          var n = el.id;

          var old = document.getElementById(this.pair);

          if (this.pair == -1 || this.pair == n) {
            this.pair = n;
          } else {
            if (this.cards[this.pair - 1] == this.cards[n - 1]) {
              old.classList.add("blocked");
              el.classList.add("blocked");
              ref.flipped[n - 1] = true;
              ref.flipped[this.pair - 1] = true;
              this.pair = -1;
              let test = true;
              for (let i = 0; i < 16; i++) {
                test = test && ref.flipped[i];
              }
              if (test) {
                this.$emit("recupObject", "tissu");
                this.plusSlides(1);
              }
            } else {
              setTimeout(function () {
                old.classList.remove("back");
                old.classList.add("front");
                el.classList.remove("back");
                el.classList.add("front");
              }, 1000);
              this.pair = -1;
            }
          }
        }
      }
    },

    plusSlides(n) {
      this.slideIndex += n;
      this.showSlides();
    },

    currentSlide(n) {
      if (this.slideIndex < n) return;
      this.slideIndex = n;
      this.showSlides();
    },

    showSlides() {
      if (this.hasLetter) {
        var slides = document.getElementsByClassName("mySlides");
        var dots = document.getElementsByClassName("dot");
        if (this.slideIndex > slides.length) {
          this.slideIndex = 1;
        }
        if (this.slideIndex < 1) {
          this.slideIndex = slides.length;
        }
        for (let i = 0; i < slides.length; i++) {
          slides[i].style.display = "none";
        }

        if (this.slideIndex < 7) {
          for (let i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" active", "");
          }

          dots[this.slideIndex - 1].className += " active";
        }
        slides[this.slideIndex - 1].style.display = "block";
      }
    }
  },
  components: {}
};
</script>

<style>
* {
  box-sizing: border-box;
}

.pix_mem {
  width: 100%;
  height: 100%;
}

.card-container {
  width: 402;
  height: 402px;
  margin-top: 40px;
  margin-left: 100px;
}

.flip-card {
  background-color: transparent;
  width: 100px;
  height: 100px;
  border: 1px solid #fbead3;
  float: left;
  perspective: 1000px; /* Remove this if you don't want the 3D effect */
}

/* This container is needed to position the front and back side */
.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}

/* Do an horizontal flip when you move the mouse over the flip box container */
.back {
  transform: rotateY(180deg);
}

.front {
  transform: rotateY(0deg);
}

.blocked {
  border: 1px solid red;
}

/* Position the front and back side */
.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden; /* Safari */
  backface-visibility: hidden;
}

/* Style the front side (fallback if image is missing) */
.flip-card-front {
  background-color: #bbb;
  color: black;
}

/* Style the back side */
.flip-card-back {
  background-color: dodgerblue;
  color: white;
  transform: rotateY(180deg);
}

.final {
  position: absolute;
  background-color: #fbead3;
  border-radius: 5px;
  padding: 3px;
  max-width: 250px;
  margin-right: auto;
  width: intrinsic; /* Safari/WebKit utilisent un nom non-standard */
  width: -moz-max-content; /* Firefox/Gecko */
  width: -webkit-max-content;
  top: -100px;
  left: -50px;
}

.img_mem {
  left: 200px;
  position: absolute;
  top: 50%; /* poussé de la moitié de hauteur du référent */
  transform: translateY(-50%);
}

.sartaq_mem {
  right: -50px;
  position: absolute;
  top: 50%; /* poussé de la moitié de hauteur du référent */
  transform: translateY(-50%);
}

.arrowfinal {
  position: relative;
  content: "";
  left: -75px;
  top: -90px;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;

  border-right: 10px solid #fbead3;
}

.big {
  top: 15%;
}
</style>
